export default __webpack_public_path__ + "static/media/small.cc109cc4.png";